'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _SVGIcon = require('ad-react-components/lib/SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

var _marketplaceContentTypeImages = require('../../../../constants/marketplace-content-type-images');

var _marketplaceContentTypeImages2 = _interopRequireDefault(_marketplaceContentTypeImages);

var _genericResult = require('../generic-result');

var _genericResult2 = _interopRequireDefault(_genericResult);

var _defaultResult = require('./default-result.scss');

var _defaultResult2 = _interopRequireDefault(_defaultResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    result: _propTypes2.default.object.isRequired,
    icon: _propTypes2.default.string,
    position: _propTypes2.default.number.isRequired,
    index: _propTypes2.default.number.isRequired,
    highlightIndex: _propTypes2.default.number,
    savedQuery: _propTypes2.default.string,
    setResultSelection: _propTypes2.default.func.isRequired,
    getContainerRect: _propTypes2.default.func.isRequired,
    scrollIntoView: _propTypes2.default.func.isRequired,
    serviceLookup: _propTypes2.default.object.isRequired
};

var defaultProps = {
    icon: '',
    highlightIndex: -1
};

var DefaultResult = function (_React$PureComponent) {
    _inherits(DefaultResult, _React$PureComponent);

    function DefaultResult(props) {
        _classCallCheck(this, DefaultResult);

        var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

        _this.getPrimaryLabel = _this.getPrimaryLabel.bind(_this);
        _this.getAppIcon = _this.getAppIcon.bind(_this);
        _this.onImageError = _this.onImageError.bind(_this);
        _this.state = { showDefaultImage: false };
        return _this;
    }

    DefaultResult.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.highlightIndex !== this.props.highlightIndex && this.props.index === this.props.highlightIndex) {
            this.props.setResultSelection(this.props.savedQuery, this.getGenericResultProps().href);
        }
    };

    DefaultResult.prototype.onImageError = function onImageError() {
        this.setState({ showDefaultImage: true });
    };

    DefaultResult.prototype.getPrimaryLabel = function getPrimaryLabel() {
        var result = this.props.result;

        return result.emptyResultText || result.subject || result.name || result.filename || result.title || result.message;
    };

    DefaultResult.prototype.getAppIcon = function getAppIcon() {
        var _props = this.props,
            icon = _props.icon,
            serviceLookup = _props.serviceLookup;
        var _props$result = this.props.result,
            source = _props$result.source,
            contentType = _props$result.content_type,
            imageUrl = _props$result.imageUrl;


        if (this.state.showDefaultImage && icon) {
            return _react2.default.createElement(_SVGIcon2.default, { type: icon, width: _defaultResult2.default.iconSize });
        }

        if (source === 'appdirect') {
            // For results that are marketplace apps, use the app's image URL.
            // For anything else, use the image that corresponds to the result's content type.
            var imageSrc = contentType === 'app' && imageUrl ? imageUrl : (0, _marketplaceContentTypeImages2.default)(contentType);

            return imageSrc ? _react2.default.createElement('img', {
                alt: 'icon',
                className: _defaultResult2.default.iconImg,
                src: imageSrc,
                onError: this.onImageError
            }) : _react2.default.createElement(_SVGIcon2.default, { type: 'file', width: _defaultResult2.default.iconSize }); // Use generic file icon as fallback
        }

        // For results where the source is a marketplace app, use the service's icon URL.
        // No icon URL would exist for non-marketplace apps (legacy apps).
        var iconUrl = serviceLookup[source] ? serviceLookup[source].iconUrl : null;
        if (iconUrl) {
            return _react2.default.createElement('img', {
                alt: 'icon',
                className: _defaultResult2.default.iconImg,
                src: iconUrl,
                onError: this.onImageError
            });
        }

        return _react2.default.createElement(_SVGIcon2.default, { type: 'file', width: _defaultResult2.default.iconSize });
    };

    DefaultResult.prototype.getGenericResultProps = function getGenericResultProps() {
        var url = this.props.result.url;


        if (url) {
            return {
                type: 'a',
                rel: 'noopener noreferrer',
                target: '_blank',
                href: url, // TODO: Add proxy-version of url when endpoint is updated
                index: this.props.index,
                highlightIndex: this.props.highlightIndex,
                getContainerRect: this.props.getContainerRect,
                scrollIntoView: this.props.scrollIntoView
            };
        }

        return {};
    };

    DefaultResult.prototype.render = function render() {
        return _react2.default.createElement(
            _genericResult2.default,
            this.getGenericResultProps(),
            _react2.default.createElement(
                'div',
                { className: _defaultResult2.default.icon },
                this.getAppIcon()
            ),
            _react2.default.createElement(
                'div',
                { className: _defaultResult2.default.content },
                this.getPrimaryLabel()
            )
        );
    };

    return DefaultResult;
}(_react2.default.PureComponent);

DefaultResult.propTypes = propTypes;
DefaultResult.defaultProps = defaultProps;

var mapStateToProps = function mapStateToProps(state) {
    return {
        serviceLookup: state.serviceLookup
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {})(DefaultResult);